import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LoginService} from './login.service';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import {RouterModule} from '@angular/router';
import {FormsModule} from '@angular/forms';
import {LoginComponent} from './login/login.component';
import {AuthRoutingModule} from './auth-routing.module';
import {AuthService} from "./auth.service";

const states = [
  {name: 'login?next', url: '/login', component: LoginComponent},
];

@NgModule({ declarations: [
        LoginComponent
    ],
    exports: [
        LoginComponent,
    ], imports: [CommonModule,
        RouterModule,
        FormsModule,
        AuthRoutingModule], providers: [
        LoginService,
        AuthService,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AuthModule { }
